module.exports = __webpack_public_path__ + "static/media/email1.fd89f409.svg";